'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sentByVisitorClient = undefined;

var _isFromVisitor = require('conversations-schema/pubnub-message/operators/isFromVisitor');

var _isEmailCapturePromptMessage = require('conversations-schema/pubnub-message/operators/isEmailCapturePromptMessage');

var _isEmailCaptureResponseMessage = require('conversations-schema/pubnub-message/operators/isEmailCaptureResponseMessage');

var _isTypicalResponseTimeMessage = require('conversations-schema/pubnub-message/operators/isTypicalResponseTimeMessage');

var _isOfficeHoursMessage = require('conversations-schema/pubnub-message/operators/isOfficeHoursMessage');

var sentByVisitorClient = exports.sentByVisitorClient = function sentByVisitorClient(message) {
  return (0, _isFromVisitor.isFromVisitor)(message) || (0, _isEmailCapturePromptMessage.isEmailCapturePromptMessage)(message) || (0, _isEmailCaptureResponseMessage.isEmailCaptureResponseMessage)(message) || (0, _isTypicalResponseTimeMessage.isTypicalResponseTimeMessage)(message) || (0, _isOfficeHoursMessage.isOfficeHoursMessage)(message);
};